import { render, staticRenderFns } from "./DeleteDialog.vue?vue&type=template&id=554af2a0&scoped=true&lang=pug&"
import script from "./DeleteDialog.vue?vue&type=script&lang=ts&"
export * from "./DeleteDialog.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteDialog.vue?vue&type=style&index=0&id=554af2a0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554af2a0",
  null
  
)

export default component.exports